import Report from './Report';
export { Dashboard } from './dashboard/Dashboard';
export { PaymentsReport } from './payments/PaymentsReport';
export { EarningsReport } from './earnings/EarningsReport';
export { ExpensesReport } from './expenses/ExpensesReport';
export { DistanceReport } from './distance/DistanceReport';
export { AttendanceReport } from './attendance/AttendanceReport';
export { PayslipReport } from './payslip/PayslipReport';
export default Report;
